import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../../Common';
import ValidatedSelect from '../../../common/forms/ValidatedSelect';

export const Subcontractor = ({ contractId }) => {
    const { data, isLoading } = useQuery({
        queryKey: ['subcontractors', contractId],
        queryFn: () => httpClient.js(ApiRoutes.typeAheads.subcontractorsByContract(contractId)),
    });

    return (
        <ValidatedSelect
            id="subcontractorCompanyId"
            name="subcontractorCompanyId"
            label="Subcontractor"
            options={data}
            isLoading={isLoading}
            required
            error="A subcontractor selection is required."
        />
    );
};